import { UtilityService } from 'app/common/services/Utility.service';
import { showPhoneNumberInString } from 'app/common/utils/common';

export class ReportGroupConst {
  static customFields = (fields: any[] = []) => {
    let data = [
      {
        title: 'Tên phòng ban',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
        field: 'name',
      },
      {
        title: 'Sô lượng chuyên viên',
        key: 'total_user',
        display: true,
        allowSort: false,
        classes: '',
        field: 'total_user',
      },
      {
        title: 'Số lượng phiếu ghi',
        key: 'total',
        display: true,
        allowSort: false,
        classes: '',
        field: 'total',
      },
    ];
    if (fields.length > 0) {
      fields.forEach(f => {
        data.push({
          title: f.title,
          key: f.key,
          display: false,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }

    data.push({
      title: 'Xếp hạng ticket',
      key: 'top',
      display: true,
      allowSort: false,
      classes: '',
      field: 'top',
    });
    return data;
  };
  static displayColumns = (fields: any[] = []) => {
    let data = [
      {
        title: 'STT',
        key: 'STT',
        display: true,
        allowSort: false,
        classes: '',
        field: 'STT',
      },
      {
        title: 'Tên phòng ban',
        key: 'name',
        display: true,
        allowSort: false,
        classes: 'text-blue',
        field: 'name',
      },
      {
        title: 'Số lượng chuyên viên',
        key: 'total_user',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'total_user',
      },
      {
        title: 'Số lượng phiếu ghi',
        key: 'total',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'total',
      },
    ];
    if (fields.length > 0) {
      fields.forEach(f => {
        const fData = f.data || [];
        for (let i = 0; i < fData.length; i++) {
          data.push({
            title: f.title + ': ' + fData[i],
            key: f.key + i,
            display: f.display,
            allowSort: false,
            classes: '',
            field: f.key,
          });
          data.push({
            title: f.title + ': ' + fData[i],
            key: f.key + i + '_percent',
            display: f.display,
            allowSort: false,
            classes: '',
            field: f.key,
          });
        }
      });
    }
    data.push({
      title: 'Xếp hạng ticket',
      key: 'top',
      display: true,
      allowSort: false,
      classes: 'text-center',
      field: 'top',
    });
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/group/group.const.ts